import { Directive } from "@angular/core";

@Directive({
    selector: '[t4ListBanner]',
    standalone: false
})
export class ListBannerDirective {}
